module.exports = __webpack_public_path__ + "static/media/network-icon.9a0fa869.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/search/network-icon.png
// module id = 706
// module chunks = 0